import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { parseEula } from '../../../markdown/parser'
import { Button } from '../../../imports'
import styles from '../../../styles.scss'

// NOTE: TQ Problem
//       calling document.body.getBoundingClientRect() returns (0, 0)
//       for the first < 400ms (on open). The position is therefore
//       incorrectly calculated. To fix this we set a timeout to run
//       after 400ms and recalculate where to position the prompt.
//       This does cause the prompt to be incorrectly displayed for
//       the first 400ms though. But since this only applies to the
//       scenario where we want to show the prompt directly on open
//       I see no reason to hide the prompt or find a better solution.
//       I repeat: In all other cases, the calculations are correct
//       the first time around so in most (if not all) cases this
//       is not a problem.

class EulaPrompt extends Component {
    constructor(props) {
        super(props)

        // Required becuase of TQ
        this.timeout = undefined

        this.state = {
            top: 0,
            left: 0,
        }
    }

    componentDidMount() {
        // We first need to draw the eula prompt, to know its size
        // and then we can calculate its correct position
        this.calculatePosition()

        // Required becuase of TQ
        this.timeout = setTimeout(() => {
            this.calculatePosition()
        }, 400)
    }

    // Required becuase of TQ
    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    }

    close = (accept) => {
        if (accept) {
            this.props.accept()
        } else {
            this.props.decline()
        }
    }

    // handleClick = (e) => {
    //     if (this.ref.contains(e.target)) {
    //         return
    //     }

    //     this.close(false)
    // }

    handleClick = () => {}

    calculatePosition = () => {
        const bodyRect = document.body.getBoundingClientRect()
        const box = this.ref.getBoundingClientRect()

        // We just calculate the body middle

        // ------------------------
        // Calculate the Y position
        // ------------------------
        // eslint-disable-next-line
        let top = bodyRect.height / 2 - box.height / 2

        // Now parse the result to get an int
        top = parseInt(top, 10)

        // Make sure the popup newer shows up to high up
        if (top < 30) top = 30

        // ------------------------
        // Calculate the X position
        // ------------------------
        // eslint-disable-next-line
        let left = bodyRect.width / 2 - box.width / 2

        // Now parse the result to get an int
        left = parseInt(left, 10)

        this.setState({ top, left })
    }

    render() {
        return (
            <div
                role="presentation"
                className={styles.background}
                onClick={e => this.handleClick(e)}
            >
                <div
                    ref={ref => (this.ref = ref)}
                    className={styles.container}
                    style={{ top: this.state.top, left: this.state.left }}
                >
                    {parseEula(this.props.eula, styles.title, styles.text)}
                    <div className={styles.buttons}>
                        <Button
                            className={styles.decline}
                            onClick={() => this.close(false)}
                            secondary
                        >
                            {this.props.declineText}
                        </Button>
                        <Button
                            className={styles.accept}
                            onClick={() => this.close(true)}
                        >
                            {this.props.acceptText}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

EulaPrompt.propTypes = {
    eula: PropTypes.string,
    acceptText: PropTypes.string,
    declineText: PropTypes.string,
    accept: PropTypes.func,
    decline: PropTypes.func,
}

export default EulaPrompt



// WEBPACK FOOTER //
// ./src/features/Eula/components/Eula/Prompt/component.js